import React from 'react';

import { t } from 'i18next';
import { Control } from 'react-hook-form';

import { TextFieldProps } from '@mui/material';

import { ControlledTextField } from 'components/shared';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';

interface FieldsProp {
  control: Control<any>;
}

export const CodeField: React.FC<TextFieldProps> = ({ ...props }) => {
  return (
    <ControlledNumericField
      {...props}
      variant="outlined"
      name="code"
      label={t('surchargesMaintenance.grid.code')}
      step={1}
    />
  );
};

export const NameField: React.FC<FieldsProp & TextFieldProps> = ({
  control,
  ...props
}) => {
  return (
    <ControlledTextField
      {...props}
      name="name"
      type="string"
      control={control}
      variant="outlined"
      label={t('surchargesMaintenance.grid.name')}
    />
  );
};
